import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Input, InputGroup, InputGroupText, Row, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";

import {CURRENCY_MXN_HEADER, CURRENCY_USD_HEADER, error, infoMsg, SAVE, saveMsg, success} from "../i18n/i18n";
import {ButtonCancel, GenericTableButton} from "../buttons/buttonsActions";
import { dishDrinkPriceService } from "../../jwt/_services/ayb/dishDrinkPriceService";
import { showToastCustom } from "../toast/customToast";

export const ConfirmPriceExchange = ({ udn, category, fbDataBaseId, onClose }) => {

    const [saving, setSaving] = useState(false)
    const [toFrom, setToFrom] = useState(false)
    // const [xapiExchange, setXapiExchange] = useState(false)

    const {register, handleSubmit } = useForm({
        defaultValues: {
            exchangeValue: '0.00',
        }
    });

    const isMounted = useRef(true)

    //Actualizar la referencia
    useEffect(() => {

        return () => {
            isMounted.current = false
        }
    },[])

    const onSubmit = (values, _) => {
        if (parseFloat(values.exchangeValue)  === 0)
            return showToastCustom(error, 'El valor debe ser mayor que cero!');

        const dataRequest = {
            fbDataBase :  { id : fbDataBaseId },
            item : {
                udn : { id : udn?.id},
                category : category,
                exchangeValue : values.exchangeValue,
                fromCurrency : toFrom ? 'USD' : 'MXN',
                toCurrency :  toFrom ? 'MXN' : 'USD'
            }
        }

        // console.log(dataRequest);
        // return;

        setSaving(true)
        dishDrinkPriceService.priceExchange(dataRequest)
            .then(result => {
                if(!result?.status)
                    return

                showToastCustom(success, saveMsg);
                onClose();
            })
            .catch( _ => {
                    showToastCustom(error, infoMsg, true);
                }
            )
            .finally(() => {
                if(isMounted.current) {
                    setSaving(false)
                }
                onClose()
            });
    }

    return (
        <div className='custom-ui'>
            <h1>{ "Actualizar precios" }</h1>

            <br/>
            <div style={{textAlign:'left'}}>
                <Form onSubmit={ handleSubmit(onSubmit) }>
                    <Row>
                        <Col md={"2"}><h4 style={ {textAlign:'center'} }>{  }</h4></Col>
                        <Col md={"8"}><h4 style={ {textAlign:'center'} }>{ "Actualiza los precios de todos los tratamientos de dolares a pesos segun el tipo de cambio:" }</h4></Col>
                        <Col md={"2"}><h4 style={ {textAlign:'center'} }>{  }</h4></Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col md={"4"}>
                            <h4 style={ {textAlign:'center'} }>{  CURRENCY_USD_HEADER }</h4>
                        </Col>
                        <Col md={"4"} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <GenericTableButton toolTip={''} icon={toFrom ? 'fa-arrow-right' : 'fa-arrow-left'} permission={'edit'} onClick={_ => setToFrom(!toFrom)}/>
                        </Col>
                        <Col md={"4"}>
                            <h4 style={ {textAlign:'center'} }>{  CURRENCY_MXN_HEADER }</h4>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col md={"3"}>{}</Col>
                        <Col md={"6"}>
                            <InputGroup>
                                <InputGroupText>$</InputGroupText>
                                <Input
                                    type="number"
                                    step=".01"
                                    min="0.00"
                                    name="exchangeValue"
                                    innerRef={register}
                                    style={{textAlign:'center'}}
                                />
                            </InputGroup>
                        </Col>
                        <Col md={"3"}></Col>
                    </Row>
                    <br/>
                    <br/>
                    <div style={{textAlign:'center'}}>
                        <ButtonCancel onClick={onClose}/>
                        &nbsp;&nbsp;
                        <Button
                            type={"submit"}
                            className="btn-add ml-auto ml-2"
                            disabled={ saving }
                        >
                            { SAVE }
                        </Button>
                        {
                            saving && <>
                                <br/><br/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                            </>
                        }
                    </div>
                </Form>
            </div>
        </div>
    );
}